import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { NoticesProvider } from '../../providers/notices/notices';
import { ToastProvider } from '../../providers/toast/toast';
import { AddComplaintsPage } from '../add-complaints/add-complaints';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';


@IonicPage()
@Component({
  selector: 'page-feedback',
  templateUrl: 'feedback.html',
})
export class FeedbackPage {

	subject: string = "";
  desc: string = "";
  officeName  : any;
  officeAddress : any ;

  constructor(public navCtrl: NavController, public navParams: NavParams, private translate: TranslateService,private noticeProvider: NoticesProvider, private toast: ToastProvider) {
  
  this.officeName = environment.officeName
  this.officeAddress = environment.officeAddress
  console.log(this.officeName);


  }

  send(){
  	if(this.subject.length == 0 || this.subject.length == 0){
  		this.toast.presentToast("Invalid fields")
  	}else {
  		this.noticeProvider.submitFeedback(this.subject, this.desc).then(val => {
  			if(val.status == "success"){
  				this.toast.presentToast("your feedback has been submitted successfully");
  				this.subject = "";
  				this.desc = "";
  			}else {
  				this.toast.presentToast("error");
  			}
  		})
  	}
  }
  
 items = [
	{icon: "ios-alert", title: "QUICK_LINKS.RAISE_COMPLAINTS", page: AddComplaintsPage, mod: "COM", type: "CREATE"},
  ]
  goTo(item: any){    
        let index = item.index? item.index: 0;
        this.navCtrl.push(item.page, {
          index
        });    
  }
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad FeedbackPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/feedback/feedback.ts